import { render, staticRenderFns } from "./ExchangeConfirm.vue?vue&type=template&id=4e168147&scoped=true&"
import script from "./ExchangeConfirm.vue?vue&type=script&lang=ts&"
export * from "./ExchangeConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeConfirm.vue?vue&type=style&index=0&id=4e168147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e168147",
  null
  
)

export default component.exports